module.exports = __webpack_public_path__ + "static/img/banner_product3.5721fbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comm/banner_product3.jpg
// module id = 6+N+
// module chunks = 0